<!-- Masho Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Masho Listing Component -->
  <app-masho-manager-listing #mashoListing>
  </app-masho-manager-listing>
</div>

<!-- Masho Add/Edit Modal -->
<app-masho-manager-add-edit
  (mashoAdded)="onMashoAdded()"
  (mashoUpdated)="onMashoUpdated()">
</app-masho-manager-add-edit>
